import { createCrudSlice } from '@crm/features/crudSliceFactory';

const module = createCrudSlice({
  name: 'crmPayments',
  path: 'payments',
  singleKey: 'payment',
});

export const paymentsActions = module.actions;
export const paymentsThunks = module.thunks;
export const paymentsSelectors = module.selectors;
export default module.reducer;
